export default "__VITE_ASSET__Bl$daC3J__"